import { createApp, type Plugin } from "vue";
import App from "@/App.vue";
import i18n from "@/i18n";
import "pusher-js/with-encryption";
import VueTippy from "vue-tippy";
import "tippy.js/dist/tippy.css";
import { buildSentryConfig } from "@lendflow/sentry";
import * as Sentry from "@sentry/vue";
import AppConfig from "@/config";
import last from "lodash/last";
import tooltipable from "@/directives/tooltipable";
import { useAnalyticsState } from "./composables/state/analyticsState";
import { VueQueryPlugin } from "@tanstack/vue-query";
import queryClient from "@/api/queries/queryClient";

/* style imports */
import "@/tailwind.css";
import "@fontsource/inter/latin.css";
/* end style imports */

export const appPlugins = [
  [i18n],
  [VueTippy, { component: "tooltip", directive: "tooltip", defaultProps: { theme: "lendflow" } }],
  [VueQueryPlugin, { queryClient, enableDevtoolsV6Plugin: true }],
];

const app = createApp(App);

const environment = last(AppConfig.apiBaseUrl?.split("://")) ?? "unknown";
Sentry.init(
  buildSentryConfig({
    app,
    dsn: AppConfig.sentryDsn,
    environment,
  }) as Parameters<typeof Sentry.init>[0]
);

appPlugins.forEach(([plugin, options]) => app.use(plugin as Plugin, options));
app.directive("tooltipable", tooltipable);

app.mount("#app");

useAnalyticsState();
